module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick-d483bb62a54609033b33145e05ccd93b.png";